import React from 'react';
import { Admin, CustomRoutes, Resource } from 'react-admin';
import { BrowserRouter, Route } from 'react-router-dom';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';
import { UserList } from './components/UserList';
import { createAuthProvider } from './react-admin/providers/authProvider';
import dataProvider from './react-admin/providers/dataProvider';
import { CognitoLogin } from './components/CognitoLogin';
import { GiftCardList } from './components/GiftCardList';
import { Config } from './components/Config';
import { Layout } from './react-admin/components/Layout';
import { UserEdit } from './components/UserEdit';
import { UserDetails } from './components/UserDetails';
import { State } from './components/State';

const provider = createAuthProvider();
const i18nProvider = polyglotI18nProvider(() => englishMessages, 'en');

const App = () => {
  return (
    <BrowserRouter>
      <Admin
        layout={Layout}
        i18nProvider={i18nProvider}
        dataProvider={dataProvider}
        authProvider={provider}
        loginPage={CognitoLogin}
        disableTelemetry
        title="Rewards Management Admin"
      >
        {(permissions) => (
          <>
            <Resource
              name="user"
              list={UserList}
              show={UserDetails}
              edit={permissions?.canEditUser() ? UserEdit : undefined}
            />
            <Resource name="gift-card" list={GiftCardList} />
            <CustomRoutes>
              {permissions?.canEditSettings() && (
                <Route path="/config" element={<Config />} />
              )}
            </CustomRoutes>
            <CustomRoutes>
              {permissions?.canEditState() && (
                <Route path="/state" element={<State />} />
              )}
            </CustomRoutes>
          </>
        )}
      </Admin>
    </BrowserRouter>
  );
};

export default App;
